import React, { useEffect, useState } from 'react';
export const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentText, setCurrentText] = useState(0);
  const textOptions = ['Structuring & Protecting Growth-Focused Businesses', 'Strategic Counsel for Corporate Excellence', 'Legal & Business Solutions for Industry Leaders'];
  useEffect(() => {
    setIsVisible(true);
    const interval = setInterval(() => {
      setCurrentText(prev => (prev + 1) % textOptions.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative h-screen flex items-center justify-center overflow-hidden" data-id="element-226">
      {/* Background with overlay */}
      <div className="absolute inset-0 bg-primary-dark" data-id="element-227">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-dark to-primary opacity-90" data-id="element-228"></div>
      </div>
      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 text-white" data-id="element-229">
        <div className="max-w-4xl mx-auto text-center" data-id="element-230">
          <div className="h-24 md:h-32 mb-8 flex items-center justify-center" data-id="element-231">
            {textOptions.map((text, index) => <h2 key={index} className={`font-serif text-3xl md:text-5xl lg:text-6xl font-bold transition-all duration-1000 absolute ${currentText === index ? 'opacity-100 transform-none' : 'opacity-0 translate-y-8'}`} data-id="element-232">
                {text}
              </h2>)}
          </div>
          <p className="text-lg md:text-xl mb-12 opacity-0 animate-fade-in" style={{
          animationDelay: '0.6s',
          animationFillMode: 'forwards'
        }} data-id="element-233">
            Elevating businesses through strategic legal counsel and business
            expertise
          </p>
          <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6 opacity-0 animate-fade-in" style={{
          animationDelay: '0.8s',
          animationFillMode: 'forwards'
        }} data-id="element-234">
            <a href="mailto:niqqannoconsult21@gmail.com?subject=Consultation%20Request&body=I'm%20interested%20in%20booking%20a%20consultation%20with%20Niqqanno%20Consulting." className="bg-gold text-primary-dark px-8 py-3 rounded font-medium hover:bg-gold-light transition-colors duration-300" data-id="element-235">
              Book Consultation
            </a>
            <a href="#services" className="border-2 border-white text-white px-8 py-3 rounded font-medium hover:bg-white hover:text-primary-dark transition-colors duration-300" data-id="element-236">
              Explore Services
            </a>
          </div>
        </div>
      </div>
      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 opacity-0 animate-fade-in" style={{
      animationDelay: '1.2s',
      animationFillMode: 'forwards'
    }} data-id="element-237">
        <div className="w-8 h-12 border-2 border-white rounded-full flex justify-center" data-id="element-238">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-bounce" data-id="element-239"></div>
        </div>
      </div>
    </section>;
};